import * as React from 'react'
import {BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import App from '../containers/App/App'
import PureApp from '../containers/PureApp/PureApp'
import Container from 'src/containers/Container'

const RouterMap = () => (
  <Router>
    <Container>
      <Switch>
        <Route path="/sider">
          <App />
        </Route>
        <Route path="/pure">
          <PureApp />
        </Route>
        <Redirect from="" to="/sider/home" />
      </Switch>
    </Container>
  </Router>
)

export default RouterMap



// WEBPACK FOOTER //
// ./src/router/RouterMap.tsx